import { useState, useEffect } from 'react';
import {
    FormLabel, FormControl, MenuItem, Select,
} from '@material-ui/core';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
    AccordionSetup, AdditionalInfo,
} from '@commonClient2/components';
import { UPDATE_GLOBAL_SETUP } from '../../store/globalSetup';
import { ShiftDisplayType } from '../../../Enums';

import './ManagerShiftDisplayPreferences.scss';

/**
 * @param {{
 *  isDisabled?: boolean;
 *  isLoading: boolean;
 *  globalSetups: GlobalSetup.GlobalSetup;
 *  globalSetupsToReset: GlobalSetup.GlobalSetup;
 *  step: number;
 * }} param0
 * */
const ManagerShiftDisplayPreferences = ({
    isLoading,
    globalSetups,
    step,
}) => {
    const { t } = useTranslation('globalSetup', { keyPrefix: 'managerShiftDisplayPreferences' });
    const dispatch = useDispatch();
    const { managerShiftDisplayPreferences: rules } = globalSetups;

    const {
        shiftDisplayType,
    } = rules;

    const [displayType, setDisplayType] = useState(shiftDisplayType);

    /**
     * @template T
     * @param {T} value
     */
    const updateStore = (value) => {
        dispatch({
            type: UPDATE_GLOBAL_SETUP,
            payload: { managerShiftDisplayPreferences: value },
        });
    };

    /**
     * @param {string} field
     * @param {*} value
     */
    const onChange = (field, value) => updateStore({ ...rules, [field]: value });

    useEffect(() => { setDisplayType(shiftDisplayType); }, [JSON.stringify(rules)]);

    const displayOptions = [
        { value: ShiftDisplayType.ShiftLabel, label: t('shiftLabel') },
        { value: ShiftDisplayType.ShiftTime, label: t('shiftTime') },
    ];

    return (
        <AccordionSetup
            stepIndex={step.toString()}
            headerTitle={t('title')}
            summary=""
            className="manager-shift-display-preferences-step"
        >
            <div className="manager-shift-display-preferences-container">
                <div className="shift-display-type-section">
                    <FormControl className="shift-display-type-control">
                        <div className="label-with-info">
                            <FormLabel id="shift-display-type-label">{t('label')}</FormLabel>
                            <AdditionalInfo
                                className="shift-display-info"
                                placement="right"
                            >
                                <div className="tooltip-content">
                                    <div className="tooltip-description">
                                        {t('tooltipDescription')}
                                    </div>
                                    <div className="tooltip-option">
                                        <strong>{t('shiftLabel')}</strong>
                                        {' '}
                                        {t('shiftLabelDescription')}
                                    </div>
                                    <div className="tooltip-option">
                                        <strong>{t('shiftTime')}</strong>
                                        {' '}
                                        {t('shiftTimeDescription')}
                                    </div>
                                </div>
                            </AdditionalInfo>
                        </div>
                        <Select
                            name="shiftDisplayType"
                            aria-labelledby="shift-display-type-label"
                            value={displayType}
                            onChange={(e) => {
                                const { value } = e.target;
                                onChange('shiftDisplayType', value);
                                setDisplayType(value);
                            }}
                            variant="outlined"
                            disabled={isLoading}
                            MenuProps={{
                                anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
                                transformOrigin: { vertical: 'top', horizontal: 'left' },
                                getContentAnchorEl: null,
                            }}
                        >
                            {displayOptions.map((option) => (
                                <MenuItem key={option.value} value={option.value}>
                                    {option.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </div>
            </div>
        </AccordionSetup>
    );
};

export default ManagerShiftDisplayPreferences;

